import initialState from "./initialState";
import { ImportOrderQueryCriteriaAction } from "../../actions/eso/actionCreators";

export function ImportOrderSearchReducer(
  state = initialState.ImportOrderSearchReducer,
  action
) {
  switch (action.type) {
    case ImportOrderQueryCriteriaAction.SET().type:
      return action.payload;

    default:
      return state;
  }
}
